import {
	Box,
	Paper,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSystemActions, useVerify } from 'stores';
import { MotionWrapper } from 'utils';

const AuthInfo = () => {
	const { t } = useTranslation();
	const verify = useVerify();
	const { getImage } = useSystemActions();

	if (!verify) return <></>;

	return (
		<MotionWrapper>
			<Stack
				p={3}
				spacing={2}
				alignItems="center"
				sx={{ overflow: 'scroll' }}
			>
				<Box
					component="img"
					sx={{
						width: '70%',
						paddingTop: '5%',
						paddingBottom: '15%',
					}}
					alt="AR_Logo"
					src={getImage('logo_ar.png')}
				/>
				{/*
				<Typography>{verify.message.title}</Typography>
				<Typography>{verify.message.content}</Typography>
				*/}

				{verify.status === 'success' && verify.totalScanCount === 1 ? ( //first time successful verify
					<Typography>{t('auth.info.firsttime.p1')}</Typography>
				) : verify.status === 'success' && verify.totalScanCount > 1 ? (
					<Typography>{t('auth.info.repeatedscan.p1')}</Typography>
				) : null}
				<TableContainer component={Paper} sx={{ overflow: 'visible' }}>
					<Table>
						{verify.status === 'success' &&
							verify.totalScanCount === 1 && (
								<TableBody>
									<TableRow>
										<TableCell component="th" scope="row">
											{t('auth.info.first')}
										</TableCell>
										<TableCell>
											{verify.firstVerifySDatetime}
										</TableCell>
									</TableRow>
								</TableBody>
							)}
						{verify.status === 'success' &&
							verify.totalScanCount > 1 && (
								<TableBody>
									<TableRow key="0">
										<TableCell component="th" scope="row">
											{t('auth.info.first')}
										</TableCell>
										<TableCell>
											{verify.firstVerifySDatetime}
										</TableCell>
									</TableRow>
									<TableRow key="1">
										<TableCell component="th" scope="row">
											{t('auth.info.last')}
										</TableCell>
										<TableCell>
											{verify.lastVerifySDatetime}
										</TableCell>
									</TableRow>
									<TableRow key="2">
										<TableCell component="th" scope="row">
											{t('auth.info.total')}
										</TableCell>
										<TableCell>
											{verify.totalScanCount}
										</TableCell>
									</TableRow>
								</TableBody>
							)}
					</Table>
				</TableContainer>
				{verify.status === 'success' && verify.totalScanCount === 1 ? (
					<Typography>{t('auth.info.firsttime.p2')}</Typography>
				) : null}
			</Stack>
		</MotionWrapper>
	);
};

export default AuthInfo;
